import type { CarbonIntensityNarrativeInput } from './carbonIntensityNarrative';
import { isFiniteNumber } from './narrativeFormatting';
import { buildTrendSentence } from './optionalClauseTokens';
import type { NarrativeTokenMap } from './narrativeTemplateEngine';

export function buildCarbonIntensityNarrativeTokens(input: CarbonIntensityNarrativeInput): NarrativeTokenMap {
  const trendSentence = buildTrendSentence(input.percentChange, input.baselineYear);
  const abs =
    input.absoluteChange != null && Number.isFinite(input.absoluteChange)
      ? ` That is a change of ${input.absoluteChange >= 0 ? '+' : ''}${input.absoluteChange.toFixed(1)} gCO₂e/kWh over the displayed period.`
      : '';
  return {
    locationName: input.locationName,
    latestYear: input.latestYear,
    baselineYear: input.baselineYear,
    carbonIntensity: input.latestGco2ePerKwh.toFixed(1),
    trendSentence,
    trendPhrase: '',
    absoluteChangeSentence: abs,
    absoluteChange: abs ? input.absoluteChange : null,
    sourceStatusSentence: input.sourceStatusSentence || '',
  };
}
